import WeatherDashboard from './WeatherDashboard';
export default function App() { return <WeatherDashboard />; }